module.exports = __webpack_public_path__ + "static/anna_video-c3055cbf909b92e5608c70add0921cd1.jpg";